import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { ValidationConfig } from "../types";

interface SearchInputProps {
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  validation?: ValidationConfig;
  showClearInside?: boolean;
  onClearInside?: () => void;
}

export function SearchInput({
  value,
  placeholder,
  onChange,
  disabled,
  validation,
  showClearInside,
  onClearInside
}: SearchInputProps) {
  
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    
    // Apply validation
    if (validation?.maxLength && newValue.length > validation.maxLength) {
      return;
    }
    
    if (validation?.pattern && newValue && !validation.pattern.test(newValue)) {
      return;
    }
    
    onChange(newValue);
  };

  return (
    <div className="relative flex-1 min-w-0">
      <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
      <Input
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        className={`pl-8 ${showClearInside ? "pr-8" : ""}`}
        disabled={disabled}
        required={validation?.required}
        minLength={validation?.minLength}
        maxLength={validation?.maxLength}
      />
      
      {/* Clear Button Inside Input */}
      {showClearInside && onClearInside && (
        <button
          type="button"
          onClick={onClearInside}
          className="absolute right-2 top-2.5 text-muted-foreground hover:text-foreground"
          aria-label="Clear search"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}

